import { ScrollArea } from '../../../components/ui/scroll-area';
import { useAnalytics } from '../../../core/analytics/useAnalytics';
import { openExternalUrl } from '../../help-feedback';
import { reviewUrl } from '../../review-prompt/reviewPromptConstants';
import { ChangelogContent } from './ChangelogContent';
import { changelog } from '../data/changelog';

export function WhatsNewSettingsTab() {
  const { track } = useAnalytics();

  const handleReviewLinkClick = () => {
    track('feature:review_link_click', { source: 'whats-new' });
    openExternalUrl(reviewUrl('whats-new'));
  };

  return (
    // Total height stays at 500px (what the Settings dialog content pane can
    // fit without overflowing into a second scrollbar); the changelog scroll
    // area flexes to fill the space above the review-link footer.
    <div className="flex h-[500px] flex-col">
      <ScrollArea className="min-h-0 flex-1 pr-4">
        <ChangelogContent entries={changelog} />
      </ScrollArea>
      <div className="border-t border-border pt-3 mt-2">
        <button
          type="button"
          onClick={handleReviewLinkClick}
          className="text-sm text-muted-foreground hover:text-foreground transition-colors"
          data-testid="whats-new-settings-review-link"
        >
          Enjoying the updates? Leave a review →
        </button>
      </div>
    </div>
  );
}
